/// <reference path="../../../../../rest.d.ts"/>
/// <reference path="../../../../../typings/index.d.ts"/>

module App {
    class NetworkPointBundleCreateOrderComponentCtrl implements ng.IController {
        public direction: Direction;
        public editableDirection: Direction;
        public matchOrder: CapacityCategory[];
        public networkPoint: NetworkPointDto;
        public isCapacityCategoryUsedInBundledSlotAssignments: Function;
        public onOrderChanged: Function;
        public dragDropListener: { orderChanged: Function };

        public $onInit(): void {
            this.dragDropListener = {
                orderChanged: () => {
                    this.onOrderChanged();
                }
            };
        }
    }

    angular.module('app').component('pkpNetworkPointBundleCreateOrder', {
        controller: NetworkPointBundleCreateOrderComponentCtrl,
        template:
            require('app/network-point-bundle/network-point-bundle-create-order.component.html'),
        bindings: {
            readonly: '<',
            isCreateMode: '<',
            direction: '<',
            editableDirection: '<',
            networkPoint: '<',
            matchOrder: '=',
            onOrderChanged: '&',
            isCapacityCategoryUsedInBundledSlotAssignments: '&'
        }
    });
}
